import { useNavigate } from 'react-router-dom'
import { useLanguage } from '../hooks/useLanguage'

export function SettingsPage() {
  const navigate = useNavigate()
  const { lang, setLang, t } = useLanguage()
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-950">
      <header className="border-b border-gray-200 bg-white dark:border-gray-800 dark:bg-gray-900">
        <div className="mx-auto flex max-w-3xl items-center gap-3 px-4 py-3">
          <button type="button" onClick={() => navigate(-1)} className="h-8 w-8 rounded-md bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-200">←</button>
          <h1 className="text-base font-semibold text-gray-900 dark:text-white">{t('设置', 'Settings')}</h1>
        </div>
      </header>
      <main className="mx-auto max-w-3xl p-4">
        <section className="rounded-xl border border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-800">
          <h2 className="text-sm font-semibold text-gray-900 dark:text-white">{t('语言', 'Language')}</h2>
          <div className="mt-3 grid grid-cols-2 gap-2">
            <button type="button" onClick={() => setLang('zh')} className={`rounded-lg px-3 py-2 text-sm font-medium ${lang === 'zh' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-200'}`}>中文</button>
            <button type="button" onClick={() => setLang('en')} className={`rounded-lg px-3 py-2 text-sm font-medium ${lang === 'en' ? 'bg-blue-600 text-white' : 'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-200'}`}>English</button>
          </div>
        </section>
        <section className="mt-4 rounded-xl border border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-gray-800">
          <h2 className="text-sm font-semibold text-gray-900 dark:text-white">{t('用户须知与数据管理', 'User Notice & Data')}</h2>
          <p className="mt-1 text-xs leading-5 text-gray-500 dark:text-gray-400">{t('查看完整用户须知、撤回确认或永久删除数据。', 'Review the user notice, withdraw confirmation, or permanently delete your data.')}</p>
          <button type="button" onClick={() => navigate('/settings/privacy')} className="mt-3 w-full rounded-lg bg-gray-100 px-3 py-2 text-sm font-medium text-gray-800 dark:bg-gray-700 dark:text-gray-100">{t('管理用户须知与数据', 'Manage User Notice & Data')}</button>
        </section>
      </main>
    </div>
  )
}
